import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router";
import authService from "../../Services/authService";
import clinicService from "../../Services/clinicService";
import utils from "../../Utils";
import strings from "../../Utils/strings";
import OffCanvas from "../common/offCanvas";
import AddDoctor from "../manageClinic/addDoctor";
import AddDocNew from "../manageClinic/AddDocNew";
import ViewSpecialityList from "./ViewSpeciality/viewSpecialityList";
import { t } from "../../Utils/translate";
import "./manageDoctor.css";
import Widgets from "../../Widgets";
import AppDialog from "../../Widgets/appDialog/appDialog";
import Component from "..";
import { useDispatch, useSelector } from "react-redux";
import { resetDeleteDoctor } from "../../modules/AddDoctor/AddDoctorSlice";
import { deleteDoctor } from "../../modules/AddDoctor/AddDoctorThunk";
import toast from "react-hot-toast";
import { RxCrossCircled } from "react-icons/rx";
import calender from "../../Assets/Images/calender.png";
import constants from "../../Utils/constants";
import Select from "react-select";

function ManageDoctor() {
  const isFetched = useRef(false);
  const nav = useNavigate();
  const [doctorDetails, setDoctorDetails] = useState([]); // filtered list
  const [allDoctors, setAllDoctors] = useState([]); // Original full list
  const [searchQuery, setSearchQuery] = useState(""); // for clearing the searched item in seach box
  const [offCanvasOpen, setOffCanvasOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [doctorUsername, setDoctorUsername] = useState("");
  const [userNameErr, setUserNameErr] = useState("");
  const [viewSpecialty, setViewSpecialty] = useState(false);
  const [doctorEmailId, setDoctorEmailId] = useState("");
  const [doctorEmailIdErr, setDoctorEmailIdErr] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [doctorOptions, setDoctorOptions] = useState([]);
  const [activateDoc, setActivateDoc] = useState(false)
  const [doctorId, setDoctorId] = useState("");
  const [activeFilter, setActiveFilter]=useState(constants.activeFilterDoctor[0])
  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };
  useEffect(() => {
    if (!isFetched.current) {
      getClinicProfile();
      isFetched.current = true;
    }
    setUserNameErr("");
  }, []);

  const getClinicProfile = async () => {
    try {
      setIsLoading(true);
      // setIsLoading(true);
      const response = await clinicService.getDoctorList();
      // setIsLoading(false);
      if (response && response.status) {
        const doctors = response.data.doctors;
        const options = doctors.map((doctor) => ({
          value: doctor._id,
          label: doctor.name,
        }));
        setDoctorOptions(options);
        setDoctorDetails(response.data.doctors); // show full list initially
        setAllDoctors(doctors); // saving original data
      }
    } catch (error) {
      // setIsLoading(false);
      // console.error("Error fetching doctor list:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // useEffect(() => {
  //   if (doctorDetails.length === 0) { // Run only if doctorDetails is empty
  //     getClinicProfile();
  //   }
  //   setUserNameErr("");
  // }, [doctorDetails]);

  const handleClose = () => {
    setOffCanvasOpen(false);
    getClinicProfile();
  };

  const disableButton = () => {
    let returnValue = false;
    if (
      utils.utilFunctions.emptyCheck(doctorUsername) &&
      userNameErr === "" &&
      utils.utilFunctions.emptyCheck(doctorEmailId) &&
      doctorEmailIdErr === ""
    ) {
      returnValue = false;
    } else {
      returnValue = true;
    }

    return returnValue;
  };
  const dispatch = useDispatch();
      const { deleteDoctorErr, deleteDoctorSuccess } = useSelector(
        (state) => state.addDoctor,
      );

    useEffect(() => {
      if(deleteDoctorErr){
        toast.error(deleteDoctorErr)
        getClinicProfile()

      }
      if(deleteDoctorSuccess){
        toast.success(t('docactSuccss'))
        getClinicProfile()
      }
      setActivateDoc(false)
      dispatch(resetDeleteDoctor())
    }, [deleteDoctorSuccess, deleteDoctorErr])

   const activateDocPositive = () =>{
    setIsLoading(true)
      dispatch(deleteDoctor({_id: doctorId}))
  }

  const handleViewSpecialtyClose = () => {
    setViewSpecialty(false);
    setTimeout(() => {
      getClinicProfile();
    }, 100); // Adjust delay time as needed
  };

  const mainSearch = (event) => {
    let searchQuery = event.target.value.toLowerCase();
    if (searchQuery === "") {
      // Reset to full list if search is cleared
      setDoctorDetails(allDoctors);
      return;
    }
    let filteredDoctors = allDoctors.filter(
      (doctor) =>
        doctor.name.toLowerCase().includes(searchQuery) ||
        doctor.employeeID.toLowerCase().includes(searchQuery)
    );
    setDoctorDetails(filteredDoctors);
  };

  const debounceSearch = (event, func, delay) => {
    let id;
    if (id) {
      clearTimeout(id);
    }
    id = setTimeout(() => {
      func(event);
    }, delay);
  };

    const handleChange = (e) => {
      setActiveFilter(e);
  };

  const filteredDoctors = doctorDetails.filter((data) => {
  if (activeFilter?.label === "Active" || activeFilter?.label === "Hoạt động" ) return data.isActive === true;
  if (activeFilter?.label === "In Active" || activeFilter?.label === "Không hoạt động") return data.isActive === false;
  return true; // default: show all
});

  return (
    <>
      {isLoading ? (
        <Widgets.CircularLoader />
      ) : (
        <div>
          {activateDoc && (
            <AppDialog
              setVisibility={(e) => {
                setActivateDoc(e);
              }}
              dialogTitle={t("actDoc")}
              dialogNegativeBtnText={t("btnCancel")}
              dialogPositiveBtnText={t("btnOkay")}
              dialogPositiveBtnCall={() => {
                activateDocPositive();
              }}
              dialogNegativeBtnCall={() => {
                setActivateDoc(false);
              }}
              view={<Component.WarningPop iconClassName="ri-error-warning-line" warningMsg={t("areYouSureActDoc")} />}
            />
          )}
          <div
            style={{
              overflow: "auto",
            }}
            className=" px-3"
          >
            <div className="d-flex justify-content-between resp-grid">
              <div className="screen-name flex-grow-1 mt-2 " >
                {t("labelManageDoctor")}
              </div>

                     <div className="flex-grow-1 mt-2 w-[0] flex justify-end mr-4 md-search items-center mb-[5px] search-mb">
                <input
                  type="text"
                  className="search-container pl-2 border-[#42ba45] border-[1px] rounded pr-5 search-bar-sm"
                  placeholder={t("searchByName")}
                  value={searchQuery}
                    onChange={(event) => {
                     const inputValue = event.target.value;

                     // Prevent first character from being a space
                   if (inputValue.length === 1 && inputValue === " ") return;

                   setSearchQuery(inputValue);
                   const trimmedValue = inputValue.trim();
                  //  debounceSearch(event, mainSearch, 1000);
                  debounceSearch({ ...event, target: { ...event.target, value: trimmedValue } }, mainSearch, 1000);
                  }}
                ></input>
                {searchQuery && (
                  <button
                    className="fixed mr-1"
                    onClick={(e) => {
                      setSearchQuery("");
                      // mainSearch(e);
                        mainSearch({ target: { value: "" } });
                    }}
                  >
                    <RxCrossCircled />
                  </button>
                )}
              </div>
       
                <div className="flex items-center mr-4 dropdwn-mb">
                   <Select
                options={constants.activeFilterDoctor}
                value={activeFilter}
                onChange={handleChange}
                isSearchable={false}
                styles={utils.appStyles.reportDropDown}
              />
                </div>
        
              <div
                className="manage-leave me-2"
                onClick={() => {
                  setViewSpecialty(true);
                }}
              >
                <button
                  type="button"
                  className="btn btn-danger leave mt-2 text-nowrap d-flex speciality-btn"
                >
                  {t("viewDeparment")}
                </button>
              </div>
                    <div
                className="dropdown more-details-clinic-profile"
                onClick={toggleDropdown}
              >
                <button className="dropbtn manage-dropbtn">
                  <i className="ri-more-2-line"></i>
                </button>
                <div className="dropdown-content more-details-clinic-profile">
                  <a
                    onClick={() => {
                      setViewSpecialty(true);
                    }}
                  >
                    {t("viewSpeciality")}
                  </a>
                  <a
                    onClick={() => {
                      setOffCanvasOpen(true);
                    }}
                  >
                    {t("labelAddDoctor")}
                  </a>
                </div>
              </div>
              <div
                className="manage-leave"
                onClick={() => {
                  setOffCanvasOpen(true);
                }}
              >
                <button
                  type="button"
                  className="btn btn-danger mt-2 text-nowrap add-doctor-btn"
                >
                  {t("labelAddDoctor")}
                </button>
              </div>

                {/* Second Row: Search (Hidden on Desktop, Visible on Mobile/Tablet) */}
  <div className="mt-3 w-full md:mt-0 lg:hidden md:hidden sm:hidden search-mb1">
    <div className="w-full flex justify-between items-center md:justify-end">
      <div className="flex-grow md:w-[400px] flex items-center relative ">
        <input
          type="text"
          className="search-container w-full pl-2 border-[#42ba45] border-[1px] rounded pr-5 search-bar-sm"
          placeholder={t("searchByName")}
          value={searchQuery}
          onChange={(event) => {
            const inputValue = event.target.value;
            if (inputValue.length === 1 && inputValue === " ") return;
            setSearchQuery(inputValue);
            const trimmedValue = inputValue.trim();
            debounceSearch({ ...event, target: { ...event.target, value: trimmedValue } }, mainSearch, 1000);
          }}
        />
        {searchQuery && (
          <button
            className="absolute right-2 text-lg"
            onClick={(e) => {
              setSearchQuery("");
              mainSearch({ target: { value: "" } });
            }}
          >
            <RxCrossCircled />
          </button>
        )}
      </div>
    </div>
  </div>
            </div>
            <OffCanvas
              show={offCanvasOpen}
              onHide={handleClose}
              title={t("labelAddDoctor")}
            >
              <AddDocNew onClose={handleClose} />
            </OffCanvas>
            <OffCanvas
              show={viewSpecialty}
              onHide={handleViewSpecialtyClose}
              title={t("labelDeparment")}
              className="speciality-offcanvas"
              specialityBodyClassName="speciality-offcanvas-body"
              iconClassName="d-flex justify-content-center offcanvas-arrow position-absolute speciality-icon"
            >
              <ViewSpecialityList onClose={handleViewSpecialtyClose} />
            </OffCanvas>
            <div className="table-wrapper">
              <table className=" table manage-doctor-table">
                <thead className="manage-doctor-heading">
                  <tr>
                    <th className="manage-table-doctor-profile-pic"></th>
                    <th className="manage-table-doctorname text-nowrap ">
                      {t("labelDoctorName")}
                    </th>
                    <th className="manage-table-doctorid text-nowrap">
                      {t("labelDoctorId")}
                    </th>
                    <th className="manage-table-qualification">
                      {t("labelQualification")}
                    </th>
                    <th className="manage-table-speciality">
                      {t("labelSpecialization")}
                    </th>
                    <th className="manage-table-mobile-number">
                      {t("labelMobile")}
                    </th>
                    <th className="manage-table-doctor-profile text-nowrap ">
                      {" "}
                      {t("doctorProfile")}
                    </th>
                  </tr>
                </thead>
                <tbody className="manage-table-body">
                  {filteredDoctors.map((data, i) => {
                    return (
                      <tr className="manage-table-row">
                        <td>
                          {" "}
                          {data.profilePic === "null" ||
                          data.profilePic === null ? (
                            <div
                              style={{ marginTop: "10px" }}
                              className="doctorProfilePic"
                            >
                              <i className="ri-nurse-line profile-clinic-img manage"></i>
                            </div>
                          ) : (
                            <div
                              style={{ marginTop: "5px" }}
                              className="doctorProfilePic"
                            >
                              <img
                                src={data.profilePic}
                                className="profile-clinic-img"
                                alt="image"
                              />
                            </div>
                          )}
                        </td>
                        <td className="text-max-length ">
                          <div className="">
                            {data.name}
                          </div>
                          {!data.isActive && 
                          <div style={{ marginTop: "2px" }} className="inactive-doc">
                             {t("inactive")}
                          </div>
                          }
                        </td>
                        <td className="text-max-length ">
                          <div
                            style={{ paddingTop: "2px" }}
                            className="custom-display-flex"
                          >
                            {data.employeeID}
                          </div>
                        </td>
                        <td className="text-max-length ">
                          <div
                            style={{ marginTop: "12px", paddingTop: "2px" }}
                            className="custom-display-flex"
                          >
                            {data.qualification}
                          </div>
                        </td>
                        <td>
                          <div style={{ marginTop: "18px" }} className="  ">
                            {data.department &&
                            data.departmentList.length < 0 ? (
                              data.department.departmentName
                            ) : (
                              <span className="depart">
                                {data.departmentList
                                  .slice(0, 3)
                                  .map((depart, i) => {
                                    let departName = [];
                                    if (
                                      i === 2 &&
                                      data.departmentList.length > 3
                                    ) {
                                      departName.push("etc..,");
                                    } else {
                                      departName.push(depart.departmentName);
                                      if (
                                        i !==
                                        data.departmentList.length - 1
                                      ) {
                                        departName.push(",");
                                      }
                                      departName.push(" ");
                                    }
                                    return <span>{departName}</span>;
                                  })}
                              </span>
                            )}
                          </div>
                        </td>
                        <td>
                          <div
                            style={{ marginTop: "12px", paddingTop: "2px" }}
                            className="custom-display-flex"
                          >
                            {data.countryCode.includes("+")
                              ? data.countryCode
                              : strings.viewProfile.plus_icon +
                                data.countryCode}{" "}
                            {data.phoneNumber}
                          </div>
                        </td>
                        <td>
                          {data.isActive ? (<button
                            type="button"
                            style={{ marginTop: "14px" }}
                            className="btn btn-sm btn-md btn-danger view-profile-button text-nowrap "
                            onClick={() => {
                              nav(utils.strings.navigation.doctorProfileView, {
                                state: {
                                  doctorId: data._id,
                                },
                              });
                              authService.setDoctorID(data._id);
                            }}
                          >
                            {t("viewProfile")}
                          </button>) : (
                            <button
                            type="button"
                            style={{ marginTop: "14px", width:"114px" }}
                            className="btn btn-sm btn-md btn-danger view-profile-button text-nowrap "
                            onClick={() => {
                             setActivateDoc(true)
                             setDoctorId(data._id)
                            }}
                          >
                            {t("activate")}
                          </button>
                          )}
                          
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
               {filteredDoctors.length === 0 && <div className="flex flex-col w-full">  
                <img className="request-img w-[10%] ml-[8%]" src={calender} alt="text"></img>
                 <label className="custom-font-weight whitespace-nowrap text-center">{t("noRecordsFound")}</label>
                 </div>}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ManageDoctor;
